import { useTranslationsContext } from '../Translations/providers/TranslationsContextProvider';
import { useIsMobile } from '../../app/hooks/useIsMobile';
import { Chip } from '../../app/components/Chip/Chip';
import { Column } from '../../app/components/Column/Column';
import { ParticipantInfoContainer, InfoContent, InfoRow, InfoTitle, InsuranceSection } from './style';
import { useParticipantInfo } from './hooks/useParticipantInfo';
import { ParticipantInfoModal } from './ParticipantInfoModal';
import { useMeetContext } from '../Meet';
import { useMemo } from 'react';

export interface ParticipantInfoProps {
	$boldColor?: string;
	$textColor?: string;
	$hcenter?: boolean;
}

export function ParticipantInfo({ $boldColor, $textColor, $hcenter }: Readonly<ParticipantInfoProps>) {
	const { meet, getInsuranceBrand } = useMeetContext();

	const insuranceBrand = useMemo(() => {
		return meet?.origin ? getInsuranceBrand(meet.origin) : undefined;
	}, [meet]);

	const {
		isProfessional,
		professionalData,
		patientData,
		duration,
		subjectShort,
		speciality,
		participantInfoModal,
		isSubjectTooLong,
		toggleParticipantInfoModal,
	} = useParticipantInfo();
	const { t } = useTranslationsContext();
	const isMobile = useIsMobile();

	return (
		<>
			<ParticipantInfoContainer>
				<Column $hcenter={$hcenter} $gap={isMobile ? 6 : 12}>
					{isProfessional && patientData && (
						<InfoRow>
							<InfoTitle $boldColor={$boldColor}>{t('participant_info.patient')}:</InfoTitle>
							<InfoContent $textColor={$textColor}> {patientData.fullName}</InfoContent>
						</InfoRow>
					)}
					{!isProfessional && professionalData && (
						<>
							<InfoRow>
								<InfoTitle $boldColor={$boldColor}>{t('participant_info.professional')}:</InfoTitle>
								<InfoContent $textColor={$textColor}> {professionalData.fullName}</InfoContent>
							</InfoRow>
							{speciality && (
								<InfoRow>
									<InfoTitle $boldColor={$boldColor}>{t('participant_info.speciality')}:</InfoTitle>
									<InfoContent $textColor={$textColor}> {speciality}</InfoContent>
								</InfoRow>
							)}
						</>
					)}
					<InfoRow>
						<InfoTitle $boldColor={$boldColor}>{t('participant_info.duration')}:</InfoTitle>
						<InfoContent $textColor={$textColor}> {duration} mins</InfoContent>
					</InfoRow>
					<InfoRow>
						<InfoTitle $boldColor={$boldColor}>{t('participant_info.subject')}:</InfoTitle>
						<InfoContent $textColor={$textColor}>
							{' '}
							{subjectShort}{' '}
							{isSubjectTooLong && (
								<Chip label={t('common.see_more')} onClick={toggleParticipantInfoModal} data-testid="see-more-chip" />
							)}
						</InfoContent>
					</InfoRow>
				{insuranceBrand?.name && (
					<InsuranceSection>
						<InfoTitle $boldColor={$boldColor}>{t('common.insurance')}:</InfoTitle>
						<Chip label={insuranceBrand.name.toUpperCase()} $bgColor={insuranceBrand.secondary} $color={insuranceBrand.primary} data-testid="insurance-chip" />
					</InsuranceSection>
				)}
				</Column>
			</ParticipantInfoContainer>
			<ParticipantInfoModal show={participantInfoModal} onClose={toggleParticipantInfoModal}></ParticipantInfoModal>
		</>
	);
}
